import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import dateFormatType from 'src/utils/dateFormatType';
import selectFormatDate from 'src/utils/selectDateFormat';
import OverflowTipography from 'src/components/OverflowTipography';
import { HAIRLINE_BORDER_COLOR } from './styleConstants';

const FIELD_LABEL_SX = {
  display: 'block',
  marginBottom: '6px',
  color: '#69727d',
  fontSize: '12px',
  fontWeight: 800,
  letterSpacing: '0.04em',
  textTransform: 'uppercase'
};

const FIELD_VALUE_SX = {
  display: 'block',
  color: '#3c4552',
  fontSize: '14px',
  fontWeight: 700
};

const Field = ({ label, value, borderRight, truncate }) => (
  <Box
    sx={{
      minHeight: '78px',
      padding: '16px 20px',
      borderBottom: `1px solid ${HAIRLINE_BORDER_COLOR}`,
      borderRight: borderRight ? `1px solid ${HAIRLINE_BORDER_COLOR}` : 0
    }}
  >
    <Typography component="span" sx={FIELD_LABEL_SX}>
      {label}
    </Typography>
    {truncate && value ? (
      <OverflowTipography
        component="strong"
        maxWidth="240px"
        fontSize={14}
        sx={FIELD_VALUE_SX}
      >
        {value}
      </OverflowTipography>
    ) : (
      <Typography component="strong" sx={FIELD_VALUE_SX}>
        {value || '—'}
      </Typography>
    )}
  </Box>
);

Field.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.node,
  borderRight: PropTypes.bool,
  truncate: PropTypes.bool
};

Field.defaultProps = {
  value: null,
  borderRight: false,
  truncate: false
};

const InvoiceFields = ({
  client,
  contractFolioWithoutPrefix,
  date,
  origin,
  categoryDescription,
  comment
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
      <Field label={t('TRANSACTION.DETAIL.CLIENT')} value={client} borderRight />
      <Field
        label={t('TRANSACTION.CONTRACT')}
        value={contractFolioWithoutPrefix}
      />
      <Field
        label={t('TRANSACTION.DATE')}
        value={date ? selectFormatDate(date, dateFormatType.DAY) : null}
        borderRight
      />
      <Field
        label={t('TRANSACTION.ORIGIN_TITLE')}
        value={origin ? t(`TRANSACTION.ORIGIN.${origin}`) : null}
      />
      <Field
        label={t('TRANSACTION.CATEGORY_TITLE')}
        value={categoryDescription}
        borderRight
      />
      <Field label={t('TRANSACTION.COMMENT')} value={comment} truncate />
    </Box>
  );
};

InvoiceFields.propTypes = {
  client: PropTypes.string,
  contractFolioWithoutPrefix: PropTypes.string,
  date: PropTypes.string,
  origin: PropTypes.string,
  categoryDescription: PropTypes.string,
  comment: PropTypes.string
};

InvoiceFields.defaultProps = {
  client: null,
  contractFolioWithoutPrefix: null,
  date: null,
  origin: null,
  categoryDescription: null,
  comment: null
};

export default InvoiceFields;
